'use client'

import { useTranslations } from 'next-intl'

import S from './ForClubsBenefits.module.scss'

const ForClubsBenefits = () => {
  const t = useTranslations('forClubsPage.benefits')

  const benefits = [
    { title: t('card1Title'), description: t('card1Description') },
    { title: t('card2Title'), description: t('card2Description') },
    { title: t('card3Title'), description: t('card3Description') },
    { title: t('card4Title'), description: t('card4Description') },
    { title: t('card5Title'), description: t('card5Description') },
    { title: t('card6Title'), description: t('card6Description') }
  ]

  return (
    <section className={S.benefitsSection}>
      <div className={S.benefitsLead}>
        <p className={S.sectionEyebrow}>{t('eyebrow')}</p>
        <h2 className={S.sectionTitle}>{t('headline')}</h2>
      </div>
      {benefits.map((item, index) => (
        <article key={`benefit-${index + 1}`} className={S.benefitCard}>
          <h3 className={S.benefitCardTitle}>{item.title}</h3>
          <p className={S.benefitCardDescription}>{item.description}</p>
        </article>
      ))}
    </section>
  )
}

export default ForClubsBenefits
